import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import createQueryHook from '@segment/utils/createQueryHook';
import { useStaticSiteBackend } from '@segment/contexts/staticSiteBackend';
export var fetchAllUseCases = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client) {
    var data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.get("/content/entries/useCase");

          case 2:
            data = _context.sent;
            return _context.abrupt("return", data !== null && data !== void 0 ? data : []);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchAllUseCases(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var createAllUseCasesQuery = function createAllUseCasesQuery(client) {
  return [["useCase", "allUseCasesQuery"], function () {
    return fetchAllUseCases(client);
  }];
};
export var fetchAllRelatedRecipes = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(client) {
    var searchParams, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            searchParams = new URLSearchParams();
            searchParams.set("select", "sys.id,fields.slug,fields.title,fields.description,fields.useCases,fields.authors,fields.experienceLevel,fields.roles,fields.industries");
            searchParams.set("fields.useCases[exists]", "true");
            _context2.next = 5;
            return client.get("/content/entries/recipe?".concat(searchParams.toString()));

          case 5:
            data = _context2.sent;
            return _context2.abrupt("return", data !== null && data !== void 0 ? data : []);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchAllRelatedRecipes(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var fetchAllUseCaseSlugs = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(client) {
    var allUseCases;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return fetchAllUseCases(client);

          case 2:
            allUseCases = _context3.sent;
            return _context3.abrupt("return", allUseCases === null || allUseCases === void 0 ? void 0 : allUseCases.map(function (useCase) {
              return useCase === null || useCase === void 0 ? void 0 : useCase.url;
            }));

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchAllUseCaseSlugs(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
export var createUseCaseQuery = function createUseCaseQuery(client, slug) {
  return [["useCase/useCaseQuery", slug], /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var allUseCases, data;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return fetchAllUseCases(client);

          case 3:
            allUseCases = _context4.sent;
            data = allUseCases.find(function (s) {
              return s.url === slug;
            });

            if (data) {
              _context4.next = 7;
              break;
            }

            throw new Error("Use case data is empty");

          case 7:
            return _context4.abrupt("return", data);

          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](0);
            console.error("Failed to find use case with ".concat(slug, ". Underlying error: ").concat(_context4.t0));

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 10]]);
  }))];
};
export var useUseCaseQuery = createQueryHook(createUseCaseQuery, useStaticSiteBackend, {
  staleTime: Infinity
});
export var createRelatedRecipesQuery = function createRelatedRecipesQuery(client, slug) {
  return [["useCase/relatedRecipes", slug], /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var allRelatedRecipes, recipes, transformedResponse;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return fetchAllRelatedRecipes(client);

          case 3:
            allRelatedRecipes = _context5.sent;
            recipes = allRelatedRecipes.reduce(function (accRecipe, recipe) {
              recipe.useCases.forEach(function (useCase) {
                if (useCase.fields.url === slug) {
                  accRecipe.push(recipe);
                }
              });
              return accRecipe;
            }, []);

            if (recipes) {
              _context5.next = 7;
              break;
            }

            throw new Error("Related use case recipes not found");

          case 7:
            transformedResponse = recipes.map(function (recipe) {
              var _recipe$authors;

              return _objectSpread(_objectSpread({}, recipe), {}, {
                authors: (_recipe$authors = recipe.authors) === null || _recipe$authors === void 0 ? void 0 : _recipe$authors.map(function (author) {
                  return _objectSpread(_objectSpread({}, author.fields), {}, {
                    headshot: {
                      title: author.fields.headshot.fields.title,
                      src: author.fields.headshot.fields.file.url
                    }
                  });
                })
              });
            });
            return _context5.abrupt("return", transformedResponse);

          case 11:
            _context5.prev = 11;
            _context5.t0 = _context5["catch"](0);
            console.error("Failed to find use case with ".concat(slug, ". Underlying error: ").concat(_context5.t0));

          case 14:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 11]]);
  }))];
};
export var useRelatedRecipesQuery = createQueryHook(createRelatedRecipesQuery, useStaticSiteBackend, {
  staleTime: Infinity
});